module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Input")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("输入栏")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("value")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("输入框的值，请使用"), _c('code', [_vm._v("v-model")]), _vm._v("获取及设置")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("size")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("输入框尺寸，可选值 "), _c('code', [_vm._v("sm")]), _vm._v("/"), _c('code', [_vm._v("md")]), _vm._v("/"), _c('code', [_vm._v("lg")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("md")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("color")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("输入框聚焦时的颜色, 支持两种格式"), _c('code', [_vm._v("#f00")]), _vm._v("/"), _c('code', [_vm._v("rgb(255,255,255)")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("label")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("标题")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("placeholder")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("占位文本/提示文本")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("输入类型")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("text")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("verify")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("验证内容，可选值 "), _c('code', [_vm._v("phone")]), _vm._v("/"), _c('code', [_vm._v("password")]), _vm._v("/"), _c('code', [_vm._v("email")]), _vm._v("/"), _c('code', [_vm._v("empty")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("reg")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("自定义验证正则")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")]), _vm._v("/"), _c('code', [_vm._v("RegExp")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("tip")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("验证错误提示")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("disabled")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否禁用")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("format")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否格式化内容，将全角符号转化为半角, "), _c('code', [_vm._v("，")]), _vm._v(" => "), _c('code', [_vm._v(",")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("readonly")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("只读")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("with_border")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否带边框")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("true")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("rows")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('code', [_vm._v("textarea")]), _vm._v("类型有效，指定默认行数")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("3")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("autosize")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('code', [_vm._v("textarea")]), _vm._v("类型有效，内容撑开高度")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("事件")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("使用")]), _vm._v(" "), _c('th', [_vm._v("结果")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("form-verify")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("验证当前选择器是否选中")]), _vm._v(" "), _c('td', [_vm._v("触发事件")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("component.$emit('form-verify')")]), _vm._v("/"), _c('code', [_vm._v("this.$root.$emit('form-verify')")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("error")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("手动触发错误提示（需要手动清除提示，否则一直存在）")]), _vm._v(" "), _c('td', [_vm._v("触发事件")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("component.$emit('error', '错误提示')")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("correct")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("手动触发正确提示")]), _vm._v(" "), _c('td', [_vm._v("触发事件")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("component.$emit('correct')")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("clear")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("手动清除提示")]), _vm._v(" "), _c('td', [_vm._v("触发事件")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("component.$emit('clear')")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("verify")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("返回验证结果")]), _vm._v(" "), _c('td', [_vm._v("监听事件")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("@verify=\"result = argument[0]\"")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("true")]), _vm._v("/"), _c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("enter")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("用户按下Enter键时触发")]), _vm._v(" "), _c('td', [_vm._v("监听事件")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("@enter=\"dosomething\"")])]), _vm._v(" "), _c('td', [_vm._v("-")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e3fc1ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/_cache/index-10.vue
// module id = 645
// module chunks = 0